import React, { useReducer, useContext } from 'react';
import firebase from 'firebase';

import { firestoreInitialize } from 'config/firebase/client';

import PlansCoverageContext from './PlansCoverageContext';
import PlansCoverageReducer from './PlansCoverageReducer';
import AuthenticationContext from 'context/Authentication/AuthenticationContext';

const PlansCoverageState = (props) => {
    const initialState = {
        getPlansCoverage: {
            plansCoverage: [],
            firstPlanCoverage: null,
            lastPlanCoverage: null,
            nextPlansCoverage: null,
            plansCoverageFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getPlansCoverageById: {
            planCoverage: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        createPlanCoverage: {
            plan: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updatePlanCoverage: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateCoverages: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        deletePlanCoverage: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
    }

    const { authenticatedState } = useContext(AuthenticationContext);

    const [state, dispatch] = useReducer(PlansCoverageReducer, initialState);

    const getPlansCoverage = (nextPage, prevPage, notPagination, country) => {
        dispatch({ type: 'GET_PLANS_COVERAGE_LOADING' });

        if (country) {
            getPlansCoveragePerCountry(nextPage, prevPage, notPagination, country);
        } else if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalPlansCoverage(nextPage, prevPage, notPagination);
        } else {
            getPlansCoveragePerCountry(nextPage, prevPage, notPagination, authenticatedState.user.pais);
        }
    };

    const getGlobalPlansCoverage = (nextPage, prevPage, notPagination) => {
        dispatch({ type: 'GET_PLANS_COVERAGE_LOADING' });

        let db = firestoreInitialize();

        if (notPagination) {
            let first = db.collection("Planes");

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
            })
            .catch(error => dispatch({ type: 'GET_PLANS_COVERAGE_ERROR', payload: { code: 'plans-coverage/error', message: error } }))   
        } else if (nextPage) {
            let first = db.collection("Planes")
                .orderBy('planId')
                .startAfter(nextPage)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Planes")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PLANS_COVERAGE_ERROR', payload: { code: 'plans-coverage/error', message: error } }))   
        } else if (prevPage) {
            let first = db.collection("Planes")
                .orderBy('planId')
                .endBefore(prevPage)
                .limitToLast(10);

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Planes")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PLANS_COVERAGE_ERROR', payload: { code: 'plans-coverage/error', message: error } }))   
        } else {
            let first = db.collection("Planes")
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Planes")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PLANS_COVERAGE_ERROR', payload: { code: 'plans-coverage/error', message: error } }))   
        }
    }

    const getPlansCoveragePerCountry = (nextPage, prevPage, notPagination, country) => {
        dispatch({ type: 'GET_PLANS_COVERAGE_LOADING' });

        let db = firestoreInitialize();

        if (notPagination) {
            let first = db.collection("Planes")
                .where('pais', '==', country)

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
            })
            .catch(error => dispatch({ type: 'GET_PLANS_COVERAGE_ERROR', payload: { code: 'plans-coverage/error', message: error } }))   
        } else if (nextPage) {
            db.collection("Planes")
                .where('planId', '==', nextPage)
                .limit(1)
                .get().then((querySnapshot) => {
                    let first = db.collection("Planes")
                    .where('pais', '==', country)
                    .startAfter(querySnapshot.docs[0])
                    .limit(10)

                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Planes")
                                .where('pais', '==', country)
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                })
                .catch(error => dispatch({ type: 'GET_PLANS_COVERAGE_ERROR', payload: { code: 'plans-coverage/error', message: error } }))   
        } else if (prevPage) {
            db.collection("Planes")
                .where('planId', '==', prevPage)
                .limit(1)
                .get().then((querySnapshot) => {

                    let first = db.collection("Planes")
                    .where('pais', '==', country)
                    .endBefore(querySnapshot.docs[0])

                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=data.length-10];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Planes")
                                .where('pais', '==', country)
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                const length = data.length - 10;

                                data.splice(0, length);

                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                })
                .catch(error => dispatch({ type: 'GET_PLANS_COVERAGE_ERROR', payload: { code: 'plans-coverage/error', message: error } }))   
        } else {
            let first = db.collection("Planes")
                .where('pais', '==', country)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Planes")
                            .where('pais', '==', country)
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PLANS_COVERAGE', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PLANS_COVERAGE_ERROR', payload: { code: 'plans-coverage/error', message: error } }))   
        }
    }

    const getPlansCoverageFilter = (dateSince, dateUntil, country, page) => {
        dispatch({ type: 'GET_PLANS_COVERAGE_FILTER_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalPlansCoverageFilter(dateSince, dateUntil, country, page);
        } else {
            getPlansCoverageFilterPerCountry(dateSince, dateUntil, authenticatedState.user.pais, page);
        }
    }

    const getGlobalPlansCoverageFilter = (dateSince, dateUntil, country, page) => {
        let db = firestoreInitialize();

        let first;

        if (dateSince && dateUntil) {
            let convertDateSince = new Date(dateSince).getTime();
            convertDateSince = convertDateSince + 86400000;
            convertDateSince = new Date(convertDateSince).setHours(0);

            let convertDateUntil = new Date(dateUntil).getTime();
            convertDateUntil = convertDateUntil + 86400000;

            first = db.collection("Planes")
            .where('createdOn', ">=", new Date(convertDateSince))
            .where('createdOn', '<=', new Date(convertDateUntil))
            .where("pais", "==", country)
        } else {
            first = db.collection("Planes")
        }

        first.get().then((documentSnapshots) => {
            let plansCoverage = documentSnapshots.docs.map(doc => doc.data())

            let nextPage;

            if (country) {
                plansCoverage = plansCoverage.filter(planCoverage => planCoverage.pais === country);
            }

            let nextPlansCoverage;

            if (page === '1') {
                nextPlansCoverage = plansCoverage.slice(10, 11);

                if (nextPlansCoverage.length === 1) {
                    nextPlansCoverage = true;
                } else {
                    nextPlansCoverage = false;
                }

                plansCoverage = plansCoverage.slice(0, 10);
            } else {
                nextPage = `${page}0`;

                nextPlansCoverage = plansCoverage.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);

                if (nextPlansCoverage.length === 1) {
                    nextPlansCoverage = true;
                } else {
                    nextPlansCoverage = false;
                }

                plansCoverage = plansCoverage.slice(parseInt(nextPage) - 10, parseInt(nextPage));
            }

            dispatch({ type: 'GET_PLANS_COVERAGE_FILTER', payload: { data: plansCoverage, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1], next: nextPlansCoverage } })
        })
        .catch(error => dispatch({ type: 'GET_PLANS_COVERAGE_FILTER_ERROR', payload: { code: 'plans-coverage/error', message: error } }))     
    }

    const getPlansCoverageFilterPerCountry = (dateSince, dateUntil, country, page) => {
        let db = firestoreInitialize();

        let first;

        if (dateSince && dateUntil) {
            let convertDateSince = new Date(dateSince).getTime();
            convertDateSince = convertDateSince + 86400000;
            convertDateSince = new Date(convertDateSince).setHours(0);

            let convertDateUntil = new Date(dateUntil).getTime();
            convertDateUntil = convertDateUntil + 86400000;

            first = db.collection("Planes")
            .where('createdOn', ">=", new Date(convertDateSince))
            .where('createdOn', '<=', new Date(convertDateUntil))
            .where("pais", "==", country)
        } else {
            first = db.collection("Planes").where("pais", "==", country)
        }

        first.get().then((documentSnapshots) => {
            let plansCoverage = documentSnapshots.docs.map(doc => doc.data())

            let nextPage;

            let nextPlansCoverage;

            if (page === '1') {
                nextPlansCoverage = plansCoverage.slice(10, 11);

                if (nextPlansCoverage.length === 1) {
                    nextPlansCoverage = true;
                } else {
                    nextPlansCoverage = false;
                }

                plansCoverage = plansCoverage.slice(0, 10);
            } else {
                nextPage = `${page}0`;

                nextPlansCoverage = plansCoverage.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);

                if (nextPlansCoverage.length === 1) {
                    nextPlansCoverage = true;
                } else {
                    nextPlansCoverage = false;
                }

                plansCoverage = plansCoverage.slice(parseInt(nextPage) - 10, parseInt(nextPage));
            }

            dispatch({ type: 'GET_PLANS_COVERAGE_FILTER', payload: { data: plansCoverage, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1], next: nextPlansCoverage } })
        })
        .catch(error => dispatch({ type: 'GET_PLANS_COVERAGE_FILTER_ERROR', payload: { code: 'plans-coverage/error', message: error } }))     
    };

    const getPlansCoverageById = (id) => {
        dispatch({ type: 'GET_PLANS_COVERAGE_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Planes").doc(id);

        docRef.get().then((doc) => {
            if (doc.exists) {
                dispatch({ type: 'GET_PLANS_COVERAGE_BY_ID', payload: doc.data() })
            } else {
                dispatch({ type: 'GET_PLANS_COVERAGE_BY_ID', payload: null })
            }
        }).catch((error) => {
            dispatch({ type: 'GET_PLANS_COVERAGE_BY_ID', payload: { code: 'plans-coverage/plans-coverage-error', message: error } })
        });
    };

    const createPlanCoverage = (data) => {
        dispatch({ type: 'CREATE_PLAN_COVERAGE_LOADING' });

        let db = firestoreInitialize();

        db.collection("Planes").add({
            planId: "",
            codigo: data.codigo,
            nombrePlan: data.nombrePlan,
            version: data.version,
            pais: data.pais,
            desde: data.desde,
            hasta: data.hasta,
            frecuencia: data.frecuencia,
            montoBase: data.montoBase,
            montoAnual: data.montoAnual,
            descripcionComercial: data.descripcionComercial,
            coberturas: data.coberturas,
            createdOn: firebase.firestore.FieldValue.serverTimestamp()
        }).then((doc) => {
            db.collection("Planes").doc(doc.id).update({
                planId: doc.id
            }).then(() => {
                dispatch({ type: 'CREATE_PLAN_COVERAGE', payload: { data: doc.id } })
            });
        })
        .catch((error) => dispatch({ type: 'CREATE_PLAN_COVERAGE_ERROR', payload: { code: 'plans-coverage/error', message: error } }))
    };

    const resetCreatePlanCoverageState = () => {
        dispatch({ type: 'CREATE_PLAN_COVERAGE_RESET_STATE' });
    };

    const updatePlanCoverage = (id, data) => {
        dispatch({ type: 'UPDATE_PLAN_COVERAGE_LOADING' });

        let db = firestoreInitialize();

        db.collection("Planes").doc(id).update({
            codigo: data.codigo,
            nombrePlan: data.nombrePlan,
            version: data.version,
            pais: data.pais,
            desde: data.desde,
            hasta: data.hasta,
            frecuencia: data.frecuencia,
            montoBase: data.montoBase,
            montoAnual: data.montoAnual,
            descripcionComercial: data.descripcionComercial,
            coberturas: data.coberturas,
        }).then(() => {
            dispatch({ type: 'UPDATE_PLAN_COVERAGE', payload: { data: data } });
        })
        .catch((error) => dispatch({ type: 'UPDATE_PLAN_COVERAGE_ERROR', payload: { code: 'plans-coverage/error', message: error } }))
    };

    const resetUpdatePlanCoverageState = () => {
        dispatch({ type: 'UPDATE_PLAN_COVERAGE_RESET_STATE' });
    };

    const updateCoverages = (id, data) => {
        dispatch({ type: 'UPDATE_COVERAGES_LOADING' });

        let db = firestoreInitialize();

        db.collection("Planes").doc(id).update({
            coberturas: data,
        }).then(() => {
            dispatch({ type: 'UPDATE_COVERAGES', payload: { data: data } });
        })
        .catch((error) => dispatch({ type: 'UPDATE_COVERAGES_ERROR', payload: { code: 'plans-coverage/error', message: error } }))
    };

    const resetUpdateCoveragesState = () => {
        dispatch({ type: 'UPDATE_COVERAGES_RESET_STATE' });
    };

    const deletePlanCoverage = (id) => {
        dispatch({ type: 'DELETE_PLAN_COVERAGE_LOADING' });

        let db = firestoreInitialize();

        db.collection("Planes").doc(id).delete().then(() => {
            dispatch({ type: 'DELETE_PLAN_COVERAGE' });
        })
        .catch((error) => dispatch({ type: 'DELETE_PLAN_COVERAGE_ERROR', payload: { code: 'plans-coverage/error', message: error } }))
    };

    const resetDeletePlanCoverageState = () => {
        dispatch({ type: 'DELETE_PLAN_COVERAGE_RESET_STATE' });
    };

    const resetPlansCoverageState = () => {
        dispatch({ type: 'PLANS_COVERAGE_RESET_STATE' });
    };

    return (
        <PlansCoverageContext.Provider value={{
            plansCoverageState: state.getPlansCoverage,
            plansCoverageByIdState: state.getPlansCoverageById,
            createPlanCoverageState: state.createPlanCoverage,
            updatePlanCoverageState: state.updatePlanCoverage,
            updateCoveragesState: state.updateCoverages,
            deletePlanCoverageState: state.deletePlanCoverage,
            getPlansCoverage,
            getPlansCoverageFilter,
            getPlansCoverageById,
            createPlanCoverage,
            updatePlanCoverage,
            updateCoverages,
            deletePlanCoverage,
            resetCreatePlanCoverageState,
            resetUpdatePlanCoverageState,
            resetDeletePlanCoverageState,
            resetUpdateCoveragesState,
            resetPlansCoverageState,
        }}>
            {props.children}
        </PlansCoverageContext.Provider>
    )
}

export default PlansCoverageState;
